import styles from "./Employee.module.scss"
import cx from "classnames"
import Image from "../../Image"

const EmployeeBlock = ({ employee }) => {
  const {
    employee_image: image,
    title: name,
    employee_email: email,
    employee_job: job,
    employee_phonenumber: telefon,
  } = employee

  return (
    <div className={cx(styles.employee, "@container")}>
      <div className={styles.imageWrapper}>
        <div className={styles.bg} />
        <div className={styles.image}>
          {image && (
            <Image
              alt={image?.alt}
              src={image?.permalink}
              fill
              style={{
                objectFit: "cover",
                objectPosition: `${image?.focus_css || "center"}`,
              }}
            />
          )}
        </div>
      </div>
      <div className={styles.content}>
        {name && <div className={styles.name}>{name}</div>}
        {job && <div className={styles.job}>{job}</div>}
        {email && <div className={styles.email}>Mail: {email}</div>}
        {telefon && <div className={styles.telefon}>Tel.: {telefon}</div>}
      </div>
    </div>
  )
}
export default EmployeeBlock
